export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/car_wraps.8d35f78.svg";